import log from 'loglevel'
import { appInsights } from './telemetry'

const logLevel = "info";
const envLevel = logLevel as log.LogLevelDesc;
const defaultLevel: log.LogLevelDesc = import.meta.env.DEV ? 'debug' : (envLevel || 'warn');
if (!envLevel) {
    log.setLevel(envLevel);
} else {
    log.setLevel(defaultLevel);
}

if (appInsights) {
    const originalFactory = log.methodFactory;
    log.methodFactory = (methodName, level, loggerName) => {
        const raw = originalFactory(methodName, level, loggerName);
        return (...msgs: unknown[]) => {
            raw(...msgs)
            if (methodName === 'error' && msgs.length) {
                const msg = msgs.map(m => (typeof m === 'string' ? m : JSON.stringify(m))).join(' ')
                appInsights.trackException({ exception: new Error(msg) })
            }
        }
    }
    if (!envLevel) {
        log.setLevel(envLevel);
    }
    log.setLevel(defaultLevel);
}

export default log;
